$(function() {
    'use strict';

    /*
     (incomplete) Usage documentation
     ================================

     HTML Attributes
     ---------------

     data-filters-dynamic indicates an element was added dynamically and should be removed when adjusting filters (e.g.
     individual deals, 'clear' buttons)

     data-filters-container-for="TYPE" indicates that an element is a container for holding "TYPE" (one of "deals"
     "form" "summary"). The html that gets generated by the ajax call for this section will be appended to the element

     data-filters-dynamic-section="TYPE" indicates that an element is a container for holding "TYPE" (one of "deals"
     "form" "summary"). It will be completely replaced by the html that gets generated by the ajax call for this section

     data-filters-placeholder-for="TYPE" indicates that "TYPE" (one of "deals" "form" "summary") from an ajax call
     should be inserted before this element

     data-filters-deal-loading-animation-target specified that this element should be faded in when added by filtering

     data-filters-action="ACTION" will bind click events on this element to trigger "ACTION" (currently only
     "load-more-deals")

     data-filters-role="state-classes" any elem with this will be targeted with the state classes listed in
     filterStateClasses below. Useful for showing/hiding loading spinners, controls and such

     data-filters-keep-filter-selections="href" indicates an elements href should be updated with chosen filter
     selections. Any attribute can be used here, not just href, as long as it contains a url.

     data-filters-input-container indicates the form or input element should be passed to serialize when generating
     the filter URL (generateNewURLFromFilterForm)

     data-filters-proxy-for="somJquerySelector" indicates that this element is a UX proxy for the
     target element specified by the selector. The element will receive the "checked" prop from the target, and
     will update the target on change. The element prop can be specified with data-filters-proxy-prop and
     defaults to "checked". The target prop can be specified with data-filters-proxy-target-prop and defaults to
     the value of data-filters-proxy-prop

     $(document).on("cdt.deals-loaded", function (event, page) {
     // triggered whenever new deals are loaded.
     // page is the page number that was loaded
     }

     $(document).on("cdt.deals-displayed", function (event, page) {
     // triggered whenever new deals are loaded and loading animations are finished.
     // page is the page number that was loaded
     }

     */

    var page = 1;
    var updateFiltersOnly = false;
    var preventPopStateUpdate = false;
    var userUpdatedFilters = false;

    var filterStates = [
        // Ajax call in progress
        'filter-state-loading',
        // Deals loaded, more deals available
        'filter-state-paginating',
        // Deals loaded, no more deals available
        'filter-state-pagination-finished',
    ];

    function scrollToTariffContainerTop() {
        var headerMenuSize = 50,
            tariffScrollOffsetSize = headerMenuSize;
        $('html, body').animate({
            scrollTop: (($('[data-tariff-container]').offset().top) - tariffScrollOffsetSize)
        }, 0);
    }

    function changeState(state) {
        if (filterStates.indexOf(state) < 0) {
            throw new Error('unknown state ' + state);
        }

        var stateClassTarget = $('[data-filters-role=state-classes]');

        $.map(filterStates, stateClassTarget.removeClass.bind(stateClassTarget));

        stateClassTarget.addClass(state);
    }

    $(document).on('click', 'a[href^="#"]', function() {
        preventPopStateUpdate = true;
    });

    $(document).on('touchstart click', 'fieldset [data-color-list] a', function() {
        if ($(this).siblings('input').prop('checked')) {
            $(this).closest('li').removeClass('selectedOption');
            $(this).siblings('input').prop('checked', false);
        } else {
            $(this).closest('li').addClass('selectedOption');
            $(this).siblings('input').prop('checked', true);
        }
        processFilterChangesFromForm();
    });

    $(document).on('click', '[data-filter-type="button"] .selectedOption label', function(e) {
        e.preventDefault();
        var checkedAttr = $(this).find('input[type="radio"]:checked');
        if (checkedAttr.length) {
            checkedAttr.removeAttr('checked');
            checkedAttr.trigger('change');
        }
        return true;
    });

    $(document).on('change', 'fieldset .filterChoice input', function() {
        if ($(this).prop('checked')) {
            $(this).closest('div').addClass('selectedOption');
        } else {
            $(this).closest('div').removeClass('selectedOption');
        }
        processFilterChangesFromForm();
    });

    $(document).on('click', '.filterChoice.network-option.selectableOption > label[data-linkable-path]', function(event) {
        var url = $(this).attr('data-linkable-path');
        event.stopImmediatePropagation();
        changeState('filter-state-loading');
        displayFilterOverlays();
        window.location.href = generateNewURLFromFilterForm(url);
    });

    $(document).on('change', 'section.checkbox input', function() {
        $(this).closest('label').toggleClass('active');
    });

    $(document).on('click', '[data-filters-action=reset]', function(event) {
        event.preventDefault();
        clearAllFilters();
        scrollToTariffContainerTop();
    });

    $(document).on('click touchstart', '[data-filters-action=submit], .filterCover', function(event) {
        event.preventDefault();
        $('#closeFilters').click();
    });

    $(document).on('click', '.filterChoice.network-option.selectableOption > label[for]', function(event) {
        event.preventDefault();
        var $for = $('#' + $(this).attr('for'));
        if ($for.prop('checked')) {
            $for.prop('checked', false);
        } else {
            $for.prop('checked', true);
        }
        processFilterChangesFromForm();
    });

    $(document).on('click', '[data-filters-action=load-more-deals]', function(event) {
        event.preventDefault();
        loadNextPage();
    });

    $(document).on('change', 'select[data-filter-type="select"]', function() {
        processFilterChangesFromForm();
        scrollToTariffContainerTop();
    });

    function openFilter() {
        $('body').addClass('preventScroll');
        if ($('.filterCover').length == 0) {
            $('body').append('<div class="filterCover"></div>');
        }
        $('body').append($('.filterPanelSlider'));
        $('.filterPanelSlider').toggleClass('openFilters');
        updateFiltersOnly = true;
    }

    $(document).on('click', '.filter-open', function(event) {
        event.preventDefault();
        openFilter();
    });

    $(document).ready(function() {
        if ($('.filterPanelSlider').length && window.location.hash == '#refine') {
            openFilter();
        }
    });

    $(document).on('click', '.summaryDisplayLink', function(event) {
        event.preventDefault();
        $('.selectedFilterListMobile').toggle(function() {
            $('.summaryDisplayLink').toggleClass('up-arrow');
        });
    });

    $('.selectedFilterListMobile').hide();

    $(window).resize(function() {
        if ($(window).width() >= 991 && $('body > .filterPanelSlider').length > 0) {
            removeFilterSidePanel();
        }
    });

    $(document).on('click', '#closeFilters', function(event) {
        event.preventDefault();
        removeFilterSidePanel();
        scrollToTariffContainerTop();
    });

    var multiSelectStates = {};

    function restoreMultiSelectState(id) {
        var section = $('#' + id);
        if (multiSelectStates[id]) {
            section.find('.toggleSwitch').addClass('up-arrow');
            section.find('.toggleGroup').show();
        } else {
            section.find('.toggleSwitch').removeClass('up-arrow');
            section.find('.toggleGroup').hide();
        }
    }

    function restoreMultiSelectStates() {
        for (var id in multiSelectStates) {
            if (multiSelectStates.hasOwnProperty(id)) {
                restoreMultiSelectState(id);
            }
        }
    }

    function toggleMultiSelectState(id) {
        multiSelectStates[id] = !multiSelectStates[id];
        restoreMultiSelectState(id);
    }

    $(document).on('click', '[data-filter-toggle=on] [data-toggle-switch]', function(event) {
        event.preventDefault();
        toggleMultiSelectState($(this).closest('section').attr('id'));
    });

    $(document).on('click', '[data-show-more-colors]', function(event) {
        event.preventDefault();
        $('[data-colors-viewport]').removeClass('smallview');
        $('[data-show-more-colors]').remove();
    });

    $(document).on('click', '.nonSelectableOption a, .nonSelectableOption input, .nonSelectableOption label', function(event) {
        event.preventDefault();
        return false;
    });

    $(document).on('click', '.selectedFilterList li.option[data-id]', function(event) {
        event.preventDefault();
        switch ($(this).attr('data-type')) {
            case 'multiselect':
            case 'network':
            case 'brand':
            case 'colour':
                var elementID = $(this).attr('data-id') + '_' + $(this).attr('data-element').toLowerCase();
                var element = document.getElementById(elementID);
                $(element).find('input').prop('checked', false);
                $(element).removeClass('selectedOption');
                break;

            case 'range':
                $('#' + $(this).attr('data-id')).val($('#' + $(this).attr('data-id') + ' option:first').val());
                $('.slider_' + $(this).attr('data-id')).slider('option', 'value', 0);
                updateSliderLabel($(this).attr('data-id'), 0);
                break;

            case 'select':
            case 'range_min':
            case 'range_max':
                $('#' + $(this).attr('data-id')).val($('#' + $(this).attr('data-id') + ' option:first').val());
                break;

            case 'checkbox':
                $('#filter_' + $(this).attr('data-id')).closest('label').click();
                break;

            case 'button':
                $('#filter_' + $(this).attr('data-id') + ' .selectedOption input[type="radio"]').prop('checked', false);
                break;

            case 'singlefeature':
                $('#filter_' + $(this).attr('data-id')).prop('checked', false).change();
                break;
        }

        if ($('.selectedFilterList').children('li').length == 0) {
            $('.selectedFilters').hide();
        }

        processFilterChangesFromForm();

    });

    $(window).bind('popstate', function(event) {
        if (!preventPopStateUpdate && typeof event.originalEvent != 'undefined' && typeof event.originalEvent.state != 'undefined') {
            updateDeals();
        }
        preventPopStateUpdate = false;
    });
    setupSliders();

    openRelevantFilterSections();
    // replaces filter button
    var filterID = $('#filter-button');

    $(filterID).attr('data-filter-id', '#filter-box-lg');

    setTileTariffHeights();
    setupHtmlTooltips();

    function removeFilterSidePanel() {
        $('body').removeClass('preventScroll');
        $('.filterPanelSlider').removeClass('openFilters');
        $('.filterCover').remove();
        $('#filter-side').prepend($('.filterPanelSlider'));
        updateFiltersOnly = false;
        processFilterChangesFromForm();
    }

    function displayFilterOverlays() {
        $('#filter-box-lg').scrollTop();
        $('.filterOverlay').show(100, function() {
            if ($('#filter-box-lg').outerHeight() > $('.filterOverlay').height()) {
                $('.filterOverlay').height($('#filter-box-lg').outerHeight());
            }
        });
    }

    function updateDealTypeLinks() {
        var queryString = window.location.search;
        queryString = queryString ? queryString.substr(1) : '';

        var newParams = $.map(queryString.split('&'), function(param) {
            if (param.indexOf('filter_') == 0 || param.indexOf('sort=') == 0) {
                return param;
            }
        });

        $('[data-filters-keep-filter-selections]').each(function(i, elem) {
            var $elem = $(elem);
            var attrName = $elem.attr('data-filters-keep-filter-selections');
            var currentLink = $elem.attr(attrName);

            var newQueryString = $.map(getQueryStringFromUrl(currentLink).split('&'), function(param) {
                if (param.indexOf('filter_') != 0 && param.indexOf('sort=') != 0) {
                    return param;
                }
            }).concat(newParams).join('&');

            var newSearchString = newQueryString ? '?' + newQueryString : '';

            $elem.attr(attrName, currentLink.replace(/([?].*)?$/, newSearchString));
        });
    }

    function updateDeals() {
        page = 1;
        changeState('filter-state-loading');
        displayFilterOverlays();
        $('[data-filters-dynamic]').remove();
        var queryOverrides = {};
        if (updateFiltersOnly) {
            queryOverrides.filtersonly = '1';
        }
        $.getJSON(document.URL, queryOverrides, dataReceived);
        updateDealTypeLinks();
    }

    function processFilterChangesFromForm() {
        userUpdatedFilters = true;
        var url = generateNewURLFromFilterForm();
        window.history.pushState(null, document.title, url);
        updateDeals();
    }

    function clearAllFilters() {
        var currentQueryString = window.location.search;
        currentQueryString = currentQueryString ? currentQueryString.substr(1) : '';

        var newQueryString = $.map(currentQueryString.split('&'), function(param) {
            if (param.indexOf('filter_') != 0) {
                return param;
            }
        }).join('&');
        newQueryString = newQueryString ? '?' + newQueryString : '';

        var url = window.location.pathname + newQueryString;

        window.history.pushState(null, document.title, url);
        updateDeals();
    }

    function generateNewURLFromFilterForm(path) {

        var form = $('[data-filters-input-container]');
        var queryString = form.serialize();
        var newQueryString = '';

        if (!window.location.origin) {
            window.location.origin = window.location.protocol + '//' + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
        }

        if (typeof path === 'undefined') {
            path = window.location.pathname;
        }

        if (window.location.search) {
            var cleanedSearchString = '';
            var searchString = window.location.search.substr(1, window.location.search.length - 1);
            var vars = searchString.split('&');
            var varCount = vars.length;
            var fullQueryString;
            var urlLocation;
            for (var i = 0; i < varCount; i++) {
                var param = vars[i].split('=');
                if (param[0].substr(0, 7) != 'filter_' && param[0] != 'sort') {
                    if (cleanedSearchString.length > 0) {
                        if (vars[i].length > 0) {
                            cleanedSearchString += '&' + vars[i];
                        }
                    } else {
                        cleanedSearchString = vars[i];
                    }
                }
            }

            if (queryString.length > 0) {
                newQueryString = cleanEmptyURLParams(queryString);
            }
            if (cleanedSearchString.length > 0) {
                fullQueryString = cleanedSearchString + '&' + newQueryString;
            } else {
                fullQueryString = newQueryString;
            }
            fullQueryString = '?' + fullQueryString;
            urlLocation = window.location.origin + path + fullQueryString;

        } else {
            fullQueryString = '?' + cleanEmptyURLParams(queryString);
            urlLocation = window.location.origin + path + fullQueryString;
        }
        return urlLocation;
    }

    function cleanEmptyURLParams(queryString) {
        var processedQueryString = '';
        if (queryString.length > 0) {
            var vars = queryString.split('&');
            var varCount = vars.length;
            for (var i = 0; i < varCount; i++) {
                var param = vars[i].split('=');
                if (param[1].length > 0) {
                    if (processedQueryString.length > 0) {
                        processedQueryString += '&' + vars[i];
                    } else {
                        processedQueryString = vars[i];
                    }
                }
            }
        }
        return processedQueryString;
    }

    function loadNextPage() {
        page += 1;
        changeState('filter-state-loading');
        $.getJSON(document.URL, {
            page: page,
            filtersUpdated: userUpdatedFilters
        }, loadDealData);
    }

    function updateFilterSummaryState() {
        if ($('.selectedFilterList li.option').length == 0) {
            $('.results-summary-panel, .results-summary-panel-mobile, .activeFiltersRow').hide();
        } else {
            $('.results-summary-panel, .results-summary-panel-mobile, .activeFiltersRow').show();
        }
    }

    updateFilterSummaryState();

    function dataReceived(data) {
        loadDealData(data);

        if (typeof data.listing.filterSummary !== 'undefined') {
            $('.results-summary-panel').html(data.listing.filterSummary).promise().done(function() {
                $('.selectedFilterListMobile').html($('.selectedFilterListDesktop').html());
            });

            updateFilterSummaryState();
        }

        $('.record-count').html(data.listing.recordCount).promise().done(function() {
            $('.record-count-mobile').html($('.record-count').html());
        });

        $('[data-filters-dynamic-section=form]').replaceWith(data.listing.filterControlForm);
        $(data.listing.filterControlForm).insertBefore('[data-filters-placeholder-for=form]');
        $(data.listing.filterControlForm).appendTo('[data-filters-container-for=form]');

        setupSliders();
        setupInverseProxyInputs();

        $('.filterOverlay').hide();
        restoreMultiSelectStates();

        $('.mobile-asa-message').html(data.asaMessage);
        $('.desktop-asa-message').html(data.asaMessage);
        $('.listing-asa-message').html(data.asaMessage);
        $('.listing-asa-message-filter').html(data.asaMessage);
        $('.product-tariff-listing-asa-message').html(data.asaMessage);
        $('.listing-asa-message-filter-traffic-table').html(data.asaMessage);
        if (typeof loadCompareQualityButton === 'function') {
            loadCompareQualityButton();
        }
    }

    function loadDealData(data) {
        animationPromise = jQuery.when();

        if (typeof data.listing.deals !== 'undefined') {

            var loadNewDeals = function(selector, insertNewElements) {
                return jQuery.when.apply(null, $(selector).map(function() {
                    var referenceElement = $(this);
                    var newElements = $(data.listing.deals);

                    var animateSelector = '[data-filters-deal-loading-animation-target]';
                    var newElementsToAnimate = newElements.find(animateSelector);
                    newElementsToAnimate = newElementsToAnimate.add(newElements.filter(animateSelector));
                    newElementsToAnimate.css({
                        display: 'none',
                        opacity: 0
                    });

                    insertNewElements(referenceElement, newElements);

                    var deferred = jQuery.Deferred();

                    function fadeElementIn(elements) {
                        if (elements.length) {
                            $(elements.shift())
                                .css({
                                    display: ''
                                })
                                .animate({
                                    opacity: 1
                                }, 150)
                                .promise()
                                .then(function() {
                                    fadeElementIn(elements);
                                });
                        } else {
                            deferred.resolve();
                        }
                    }

                    fadeElementIn(newElementsToAnimate.toArray());
                    setTileTariffHeights();
                    setupHtmlTooltips();
                    return deferred.promise();
                }).toArray());
            };

            var animationPromise = jQuery.when.apply(null, [].concat.apply([], [
                loadNewDeals('[data-filters-placeholder-for=deals]', function(referenceElem, newElements) {
                    newElements.insertBefore(referenceElem);
                }),
                loadNewDeals('[data-filters-container-for=deals]', function(container, newElements) {
                    newElements.appendTo(container);
                }),
                loadNewDeals('[data-filters-dynamic-section=deals]', function(container, newElements) {
                    container.replaceWith(newElements);
                })
            ]));
        }

        countdownClock.init('.tag-countdown');

        animationPromise.then(function() {
            if (data.listing.islastpage) {
                changeState('filter-state-pagination-finished');
            } else {
                changeState('filter-state-paginating');
            }
            $(document).trigger('cdt.deals-displayed', [page]);
        });

        $(document).trigger('cdt.deals-loaded', [page]);
    }

    function setupSliders() {
        $('.sliderFilter').each(function() {
            var id = $(this).attr('data-controller');
            var maxSteps = $('#' + id + ' option').length - 1;
            var dataController = $('#' + id);
            $(this).slider({
                min: 0,
                max: maxSteps,
                disabled: dataController.prop('disabled'),
                value: dataController.prop('selectedIndex'),
                step: 1,
                create: function() {
                    id = $(this).attr('data-controller');
                    updateSliderLabel(id, $('#' + id).prop('selectedIndex'));

                },
                slide: function(event, ui) {
                    id = $(this).attr('data-controller');
                    updateSliderLabel(id, ui.value);
                },
                change: function(event, ui) {
                    id = $(this).attr('data-controller');
                    if (ui.value != $('#' + id).prop('selectedIndex')) {
                        updateSliderLabel(id, ui.value);
                        $('#' + id + ' option').eq(ui.value).prop('selected', true);
                        processFilterChangesFromForm();
                    }
                }
            });
        });
    }

    function setupInverseProxyInputs() {
        $('[data-filters-proxy-for]').each(function(i, elem) {
            var $elem = $(elem);
            var $target = $($elem.attr('data-filters-proxy-for'));
            var $targetChangeWatch = $target.closest('input, select');
            var prop = $elem.attr('data-filters-proxy-prop') || 'checked';
            var targetProp = $elem.attr('data-filters-proxy-target-prop') || prop;
            var inverse = $elem.is('[data-filters-proxy-inverse]');

            function processPropVal(propVal) {
                return inverse ? !propVal : propVal;
            }

            $elem.prop(prop, processPropVal($target.prop(targetProp)));

            $elem.on('change', function() {
                $target.prop(targetProp, processPropVal($elem.prop(prop))).change();
            });

            $targetChangeWatch.on('change', function() {
                $elem.prop(prop, processPropVal($target.prop(targetProp)));
            });
        });
    }

    setupInverseProxyInputs();
    function getSliderLabel(sliderId, selectedIndex) {
        return $('#' + sliderId + ' option').eq(selectedIndex).text();
    }

    function updateSliderLabel(sliderId, selectedIndex) {
        var ddValue = getSliderLabel(sliderId, selectedIndex);
        $('#slider_label_' + sliderId).html(ddValue);
    }

    function cleanUpEmptySelects() {
        $('section select').each(function() {
            if ($(this).find('option').length <= 1) {
                $(this).attr('disabled', true);
                $(this).closest('.select').addClass('disabled');
            }
        });
    }

    setTileTariffHeights();
    setupHtmlTooltips();

    cleanUpEmptySelects();
    updateDealTypeLinks();
    function openRelevantFilterSections() {
        $('section .toggleSwitch').each(function() {
            // Open toggle boxes with selections
            var $elem = $(this),
                $section = $elem.closest('section');
            if ($section.find(':checked').length || $section.attr('data-default-toggle-state') == 'open') {
                $elem.click();
            }
        });
    }

    function getQueryStringFromUrl(url) {
        var tmpElem = document.createElement('a');
        tmpElem.href = url;
        return tmpElem.search ? tmpElem.search.substr(1) : '';
    }

    $(document).bind('website.updatedeals', function() {
        updateDeals();
    });
});

/* Tiles
 ================================================== */

function setTileTariffHeights() {

    /* Set Tariff Section to be the same in all boxes */
    var maxHeight = 0;
    $('.tiles .tile .tile-tariff').removeAttr('style');
    $('.tiles .tile .tile-tariff').each(function() {
        if ($(window).width() < 768) {
            maxHeight = $(this).height() + 40;
        } else if ($(this).height() > maxHeight) {
            maxHeight = $(this).height();
        }
    }).css('min-height', maxHeight);

    /* Set Tariff Box Size to be the same in all boxes */
    maxHeight = 0;
    $('.tiles .tile').removeAttr('style');
    $('.tiles .tile').each(function() {
        if ($(window).width() < 768) {
            maxHeight = $(this).height() + 40;
        } else if ($(this).height() > maxHeight) {
            maxHeight = $(this).height();
        }
    }).css('height', maxHeight);
}

/* HTML tooltips
 ================================================== */

function setupHtmlTooltips() {
    $('[data-toggle="html-tooltip"]').tooltip({
        placement: 'top',
        html: 'true'
    });
    $('[data-toggle="wishlist-tooltip"]').tooltip({
        placement: 'top',
        html: 'true',
        trigger: 'manual'
    });
}
